import {Box, Flex, FormLabel} from '@chakra-ui/react';
import React, {useState} from 'react';
import {get} from '../../service/ApiService';
import {Client} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import Select from 'react-select';
import {useQuery} from 'react-query';
import {useClient} from '../../views/Maintenance/ClientMaintenance';

export default function ClientMaintenanceSelect() {
  const {selectedClientId, setSelectedClientId} = useClient();
  const [toast, setToast] = useState('');

  const {data, isLoading} = useQuery(['client', 'clientList'], () => get(Client.LIST + '?PageSize=1000'), {
    onError: () => {
      setToast({error: 'Error loading clients'});
    },
  });

  const clients =
    data?.data?.map(client => ({
      value: client?.id,
      label: `${client?.clId} | ${client?.clCname ?? ''}`,
    })) ?? [];

  const selectedClient = clients.find(client => client.value === selectedClientId) ?? null;

  return (
    <Flex mr="auto" alignItems="center">
      <FormLabel color="white" fontSize="sm" mb="-0.5" ml="1">
        Select Client
      </FormLabel>
      <Box width={250}>
        <Select
          value={selectedClient}
          onChange={val => setSelectedClientId(val.value)}
          options={clients}
          isDisabled={clients.length <= 0 || isLoading}
        />
      </Box>
      <ErrorHelper toastResponse={toast} />
    </Flex>
  );
}
